import { Add } from 'iconsax-react'
import { DialogTrigger } from '../../../components/ui/dialog'
import Card from '../../../components/Card'

export default function NewSimulationCard({
  onClick,
}: {
  onClick: () => void
}) {
  return (
    <DialogTrigger className="grow" onClick={onClick}>
      <Card
        variant="company"
        showWatermark
        className="h-12 items-center max-sm:flex-row max-sm:justify-between md:h-full"
      >
        <div className="flex flex-col items-start gap-2.5">
          <h3 className="text-2xl font-semibold max-sm:text-sm">
            Nova Simulação
          </h3>
          <p className="text-xs max-sm:hidden">
            Simule uma transferência em minutos
          </p>
        </div>
        <span className="rounded-full bg-white p-1.5 max-sm:p-1">
          <Add className="text-primary max-sm:size-4" size={34} />
        </span>
      </Card>
    </DialogTrigger>
  )
}
